module.exports = __webpack_public_path__ + "static/logo-b925401ed86787860d07fa023147dfe7.png";